import {
  Home, ArrowLeftRight, Landmark, Pickaxe, Wrench,
  TrendingUp, Droplets, BarChart3, Coins, Layers, Wallet,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  label: string
  path: string
  icon: LucideIcon
  sort: number
  enabled: boolean
  children?: NavItem[]
}

export const navConfig: NavItem[] = [
  { label: 'home', path: '/', icon: Home, sort: 0, enabled: true },
  {
    label: 'trade', path: '/swap', icon: ArrowLeftRight, sort: 1, enabled: true,
    children: [
      { label: 'swap', path: '/swap', icon: TrendingUp, sort: 0, enabled: true },
      { label: 'liquidity', path: '/pool', icon: Droplets, sort: 1, enabled: true },
    ],
  },
  {
    label: 'lend', path: '/lend/market', icon: Landmark, sort: 2, enabled: false,
    children: [
      { label: 'market', path: '/lend/market', icon: BarChart3, sort: 0, enabled: true },
      { label: 'assets', path: '/lend/assets', icon: Coins, sort: 1, enabled: true },
    ],
  },
  {
    label: 'mining', path: '/mining/trade', icon: Pickaxe, sort: 3, enabled: false,
    children: [
      { label: 'tradeMining', path: '/mining/trade', icon: TrendingUp, sort: 0, enabled: true },
      { label: 'liquidityMining', path: '/mining/liquidity', icon: Droplets, sort: 1, enabled: true },
      { label: 'lendMining', path: '/mining/lend', icon: Landmark, sort: 2, enabled: true },
    ],
  },
  { label: 'vault', path: '/vault', icon: Layers, sort: 4, enabled: false },
  {
    label: 'tools', path: '/tools/create-account', icon: Wrench, sort: 5, enabled: true,
    children: [
      { label: 'createAccount', path: '/tools/create-account', icon: Wallet, sort: 0, enabled: true },
    ],
  },
]
